__turbopack_context__.v({
  "body": "style-module-scss-module__hqXqJq__body",
  "choice": "style-module-scss-module__hqXqJq__choice",
  "choice__active": "style-module-scss-module__hqXqJq__choice__active",
  "numberPremium": "style-module-scss-module__hqXqJq__numberPremium",
  "placementsPremium": "style-module-scss-module__hqXqJq__placementsPremium",
  "premiumContainer": "style-module-scss-module__hqXqJq__premiumContainer",
  "pricesPremium": "style-module-scss-module__hqXqJq__pricesPremium",
});
